import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "./BaseSongManagerPage.css";

const API = "/yt-song/web/base-songs";

export default class BaseSongManagerPage extends Component {
    loadRequestId = 0;

    state = {
        tab: "review",
        items: [],
        nextCursor: null,
        loading: false,
        detail: null,
        detailMode: null,
        detailLoading: false,
        editAuthor: "",
        editGenre: "",
        assignTargets: {},
        searchQuery: "",
        searching: false,
        createModal: null,
        baseSongSearchQuery: "",
        baseSongSearchResults: [],
        searchingBaseSongs: false,
        candidateDetail: null,
        linkedBaseSong: null
    };

    componentDidMount() {
        const params = new URLSearchParams(window.location.search || "");
        const tab = params.get("tab");
        const allowed = ["review", "missingLyric", "baseReview", "missingMetadata", "all"];
        if (tab && allowed.indexOf(tab) >= 0) {
            this.setState({ tab: tab }, () => this.loadPage(true));
        } else {
            this.loadPage(true);
        }
    }

    endpoint = path => global.config.apiDomain + API + path;

    responseData = response => response && response.data ? response.data.data : null;

    loadPage = async reset => {
        const requestId = ++this.loadRequestId;
        const requestedTab = this.state.tab;
        this.setState({ loading: true });
        try {
            const cursor = reset ? null : this.state.nextCursor;
            const beatReview = requestedTab === "review" || requestedTab === "missingLyric";
            const params = beatReview
                ? { limit: 50, cursor: cursor, missingLyric: requestedTab === "missingLyric" }
                : {
                    missingMetadata: requestedTab === "missingMetadata",
                    reviewOnly: requestedTab === "baseReview",
                    limit: 50,
                    cursor: cursor
                };
            const response = await axios.get(this.endpoint(beatReview ? "/review/list" : "/list"), {
                params: params
            });
            if (requestId !== this.loadRequestId || requestedTab !== this.state.tab) return;
            const page = this.responseData(response) || {};
            this.setState(state => ({
                items: reset ? (page.items || []) : state.items.concat(page.items || []),
                nextCursor: page.nextCursor || "END"
            }));
        } catch (error) {
            if (requestId === this.loadRequestId) toast.error(this.errorMessage(error));
        } finally {
            if (requestId === this.loadRequestId) this.setState({ loading: false });
        }
    };

    switchTab = tab => {
        this.setState({ tab: tab, items: [], nextCursor: null, detail: null, detailMode: null,
            searchQuery: "", baseSongSearchQuery: "", baseSongSearchResults: [], candidateDetail: null }, () => this.loadPage(true));
    };

    search = async event => {
        if (event) event.preventDefault();
        const query = this.state.searchQuery.trim();
        if (!query) {
            await this.loadPage(true);
            return;
        }
        this.setState({ searching: true, detail: null, nextCursor: "END" });
        try {
            const review = this.state.tab === "review" || this.state.tab === "missingLyric";
            const response = await axios.get(this.endpoint(review ? "/review/search" : "/search"), {
                params: {
                    query: query,
                    limit: 100,
                    missingLyric: this.state.tab === "missingLyric",
                    missingMetadata: this.state.tab === "missingMetadata"
                }
            });
            let items = this.responseData(response) || [];
            if (this.state.tab === "baseReview") {
                items = items.filter(item => item.status === "PENDING_REVIEW");
            } else if (this.state.tab === "missingMetadata") {
                items = items.filter(item => !item.authorName || !item.genre);
            }
            this.setState({ items: items });
        } catch (error) {
            toast.error(this.errorMessage(error));
        } finally {
            this.setState({ searching: false });
        }
    };

    openDetail = async (id, options) => {
        const keep = options && options.keep;
        if (id === undefined || id === null || id === "") {
            toast.error("Không đọc được Song ID từ danh sách; đang tải lại dữ liệu");
            await this.loadPage(true);
            return;
        }
        this.setState(keep
            ? { detailLoading: true }
            : { detailLoading: true, detail: null, candidateDetail: null });
        try {
            const review = this.state.tab === "review" || this.state.tab === "missingLyric";
            const response = await axios.get(this.endpoint(review ? "/review/song/" + id : "/" + id));
            const detail = this.responseData(response);
            let linkedBaseSong = null;
            if (review && detail && detail.linkedBaseSongId) {
                const linked = await axios.get(this.endpoint("/" + detail.linkedBaseSongId));
                linkedBaseSong = this.responseData(linked);
            }
            this.setState({
                detail: detail,
                detailMode: review ? "review" : "base-song",
                editAuthor: detail.authorName || "",
                editGenre: detail.genre || "",
                baseSongSearchQuery: keep ? this.state.baseSongSearchQuery : "",
                baseSongSearchResults: keep ? this.state.baseSongSearchResults : [],
                candidateDetail: null,
                linkedBaseSong: linkedBaseSong
            });
        } catch (error) {
            toast.error(this.errorMessage(error));
        } finally {
            this.setState({ detailLoading: false });
        }
    };

    saveMetadata = async () => {
        const detail = this.state.detail;
        if (!detail) return;
        try {
            await axios.post(this.endpoint(""), {
                id: detail.id,
                songName: detail.songName,
                lyric: detail.fullLyric,
                authorName: this.state.editAuthor,
                genre: this.state.editGenre
            });
            toast.success("Đã cập nhật tác giả và thể loại");
            await this.openDetail(detail.id);
            await this.loadPage(true);
        } catch (error) {
            toast.error(this.errorMessage(error));
        }
    };

    approveReview = async () => {
        const detail = this.state.detail;
        if (!detail) return;
        try {
            await axios.post(this.endpoint("/review/approve"), { baseSongId: detail.id });
            toast.success("Đã duyệt BaseSong");
            this.setState({ detail: null });
            await this.loadPage(true);
        } catch (error) {
            toast.error(this.errorMessage(error));
        }
    };

    openBaseSongDetail = async id => {
        this.setState({ detailLoading: true, candidateDetail: null });
        try {
            const response = await axios.get(this.endpoint("/" + id));
            const detail = this.responseData(response);
            this.setState({
                detail: detail,
                detailMode: "base-song",
                editAuthor: (detail && detail.authorName) || "",
                editGenre: (detail && detail.genre) || "",
                linkedBaseSong: null,
                candidateDetail: null
            });
        } catch (error) {
            toast.error(this.errorMessage(error));
        } finally {
            this.setState({ detailLoading: false });
        }
    };

    unlinkBeat = async (songId, baseSongId) => {
        if (!window.confirm("Hủy liên kết beat này khỏi BaseSong?")) return;
        try {
            await axios.post(this.endpoint("/unlink"), { songId: songId, baseSongId: baseSongId });
            toast.success("Đã hủy liên kết beat khỏi BaseSong");
            if (this.state.detailMode === "base-song") {
                await this.openBaseSongDetail(baseSongId || this.state.detail.id);
            } else if (this.state.detailMode === "review") {
                const stayId = this.state.detail && this.state.detail.songId ? this.state.detail.songId : songId;
                await this.openDetail(stayId, { keep: true });
            }
            await this.loadPage(true);
        } catch (error) {
            toast.error(this.errorMessage(error));
        }
    };

    assignBeat = async songId => {
        const target = Number(this.state.assignTargets[songId]);
        if (!target) {
            toast.error("Nhập BaseSong ID đích");
            return;
        }
        if (!window.confirm("Gắn beat này vào BaseSong " + target + "?")) return;
        try {
            await axios.post(this.endpoint("/assign"), { songId: songId, baseSongId: target });
            toast.success("Đã gắn beat vào BaseSong " + target);
            if (this.state.tab === "review" || this.state.tab === "missingLyric") {
                await this.openBaseSongDetail(target);
                await this.loadPage(true);
            } else {
                await this.openDetail(this.state.detail.id);
            }
        } catch (error) {
            toast.error(this.errorMessage(error));
        }
    };

    openCreateBaseSongModal = () => {
        const detail = this.state.detail;
        if (!detail) return;
        this.setState({
            createModal: {
                songId: detail.songId,
                songName: detail.songName || "",
                authorName: detail.suggestedAuthorName || "",
                genre: detail.suggestedGenre || ""
            }
        });
    };

    updateCreateModal = (field, value) => {
        this.setState(state => ({ createModal: Object.assign({}, state.createModal, { [field]: value }) }));
    };

    createBaseSongFromReview = async () => {
        const form = this.state.createModal;
        if (!form) return;
        if (!form.songName.trim() || !form.authorName.trim() || !form.genre.trim()) {
            toast.error("Cần kiểm tra và nhập đủ tên bài, tác giả và thể loại");
            return;
        }
        try {
            await axios.post(this.endpoint("/review/create"), form);
            const created = this.responseData(response);
            toast.success("Đã tạo BaseSong mới và gắn beat");
            this.setState({ createModal: null });
            if (created && created.id) await this.openBaseSongDetail(created.id);
            await this.loadPage(true);
        } catch (error) {
            toast.error(this.errorMessage(error));
        }
    };

    searchBaseSongs = async event => {
        if (event) event.preventDefault();
        const query = this.state.baseSongSearchQuery.trim();
        if (!query) return;
        this.setState({ searchingBaseSongs: true });
        try {
            const response = await axios.get(this.endpoint("/search"), { params: { query: query, limit: 50 } });
            this.setState({ baseSongSearchResults: this.responseData(response) || [] });
        } catch (error) {
            toast.error(this.errorMessage(error));
        } finally {
            this.setState({ searchingBaseSongs: false });
        }
    };

    openCandidateDetail = async baseSongId => {
        try {
            const response = await axios.get(this.endpoint("/" + baseSongId));
            this.setState({ candidateDetail: this.responseData(response) });
        } catch (error) {
            toast.error(this.errorMessage(error));
        }
    };

    renderSearch() {
        return (
            <form className="form-inline mb-3 base-song-search" onSubmit={this.search}>
                <input className="form-control mr-2" value={this.state.searchQuery}
                       placeholder={this.state.tab === "review" || this.state.tab === "missingLyric"
                           ? "Tìm beat theo ID hoặc tên bài" : "Tìm BaseSong theo tên bài"}
                       onChange={event => this.setState({ searchQuery: event.target.value })} />
                <button className="btn btn-outline-primary mr-2" disabled={this.state.searching} type="submit">
                    {this.state.searching ? "Đang tìm..." : "Tìm kiếm"}
                </button>
                {this.state.searchQuery && <button className="btn btn-link" type="button" onClick={() =>
                    this.setState({ searchQuery: "" }, () => this.loadPage(true))}>Xóa tìm kiếm</button>}
            </form>
        );
    }

    errorMessage = error => {
        const response = error && error.response && error.response.data;
        return (response && (response.message || response.error)) || (error && error.message) || "Có lỗi xảy ra";
    };

    renderTable() {
        const { items, loading, nextCursor } = this.state;
        const review = this.state.tab === "review" || this.state.tab === "missingLyric";
        const visibleItems = review ? items.filter(item => item.songId !== undefined && item.songId !== null) : items;
        return (
            <div className="card base-song-card">
                <div className="table-responsive">
                    <table className="table table-hover mb-0">
                        <thead><tr>
                            <th>ID</th><th>Tên bài</th>
                            {review ? <React.Fragment><th>Ca sĩ</th><th>Thể loại beat</th><th>Lyric score</th><th>Trạng thái</th></React.Fragment>
                                : <React.Fragment><th>Tác giả</th><th>Thể loại</th><th>Trạng thái</th><th>Số beat</th></React.Fragment>}
                            <th></th>
                        </tr></thead>
                        <tbody>
                        {visibleItems.map(item => <tr key={review ? item.songId : item.id}
                            className={review && this.state.detail && this.state.detail.songId === item.songId ? "table-warning" : ""}>
                            <td>{review ? item.songId : item.id}</td>
                            <td>{item.songName}</td>
                            {review ? <React.Fragment>
                                <td>{item.singer || "-"}</td><td>{item.genre || "-"}</td>
                                <td>{typeof item.lyricScore === "number" ? item.lyricScore.toFixed(3) : "-"}</td>
                                <td><span className="badge badge-warning">{item.status}</span></td>
                            </React.Fragment> : <React.Fragment>
                                <td>{item.authorName || <span className="text-muted">Chưa có</span>}</td>
                                <td>{item.genre || <span className="text-muted">Chưa có</span>}</td>
                                <td><span className={
                                    item.status === "PENDING_REVIEW" ? "badge badge-warning"
                                        : item.status === "PENDING_AI" ? "badge badge-danger"
                                            : "badge badge-info"
                                }>
                                    {item.status === "PENDING_REVIEW" ? "Chờ kiểm duyệt tác giả/thể loại"
                                        : item.status === "PENDING_AI" ? "Thiếu tác giả/thể loại"
                                            : item.status}
                                </span></td>
                                <td>{item.beatCount || 0}</td>
                            </React.Fragment>}
                            <td><button className="btn btn-sm btn-outline-primary" onClick={() => this.openDetail(review ? item.songId : item.id)}>Chi tiết</button></td>
                        </tr>)}
                        {!loading && visibleItems.length === 0 && <tr><td colSpan="7" className="text-center text-muted py-4">{
                            review ? "Không có beat cần review"
                                : this.state.tab === "missingMetadata" ? "Không có BaseSong thiếu tác giả/thể loại"
                                    : "Không có BaseSong"
                        }</td></tr>}
                        </tbody>
                    </table>
                </div>
                <div className="card-footer text-center">
                    {loading ? "Đang tải..." : nextCursor !== "END" && <button className="btn btn-outline-secondary" onClick={() => this.loadPage(false)}>Tải thêm</button>}
                </div>
            </div>
        );
    }

    renderDetail() {
        const detail = this.state.detail;
        if (this.state.detailLoading) return <div className="base-song-detail"><div className="text-center p-5">Đang tải chi tiết...</div></div>;
        if (!detail) return null;
        if (this.state.detailMode === "review") return this.renderReviewDetail(detail);
        return (
            <div className="base-song-detail">
                <div className="base-song-detail-dialog">
                    <div className="d-flex justify-content-between align-items-start">
                        <div><h3>{detail.songName}</h3><div className="text-muted">BaseSong #{detail.id}</div></div>
                        <button className="btn btn-light" onClick={() => this.setState({ detail: null, detailMode: null, candidateDetail: null, linkedBaseSong: null })}>Đóng</button>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-4"><b>Trạng thái</b><div>{detail.status}</div></div>
                        <div className="col-md-4"><b>Số beat</b><div>{detail.beatCount}</div></div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-6"><label>Tác giả</label><input className="form-control" value={this.state.editAuthor} onChange={event => this.setState({ editAuthor: event.target.value })} /></div>
                        <div className="col-md-6"><label>Thể loại</label><input className="form-control" value={this.state.editGenre} onChange={event => this.setState({ editGenre: event.target.value })} /></div>
                    </div>
                    <div className="mt-3">
                        <button className="btn btn-primary mr-2" onClick={this.saveMetadata}>Lưu thông tin</button>
                        {detail.status === "PENDING_REVIEW" && <button className="btn btn-success" onClick={this.approveReview}>Duyệt BaseSong</button>}
                    </div>
                    <h5 className="mt-4">Lời bài hát mẫu đầy đủ</h5>
                    <pre className="base-song-lyric">{detail.fullLyric || "Không có lời hợp lệ"}</pre>
                    <h5 className="mt-4">Các beat thuộc BaseSong ({(detail.beats || []).length})</h5>
                    {(detail.beats || []).map(beat => <details className="base-song-beat" key={beat.id}>
                        <summary>
                            <b>#{beat.id} - {beat.songName}</b>{beat.representative ? <span className="badge badge-primary ml-2">Beat mẫu</span> : null}
                            <span className="ml-2 text-muted">{beat.singer || "Không rõ ca sĩ"}</span>
                        </summary>
                        <div className="row mt-3">
                            <div className="col-md-4">Thể loại beat: {beat.genres || "Chưa có"}</div>
                            <div className="col-md-4">BPM: {beat.bpm || "-"}</div>
                            <div className="col-md-4">Key: {beat.key || "-"}</div>
                        </div>
                        <div className="mt-2 text-muted">Lyric score: {typeof beat.lyricScore === "number" ? beat.lyricScore.toFixed(3) : "-"} · {beat.linkStatus || "-"}</div>
                         <button className="btn btn-outline-warning btn-sm mt-2" onClick={() => this.unlinkBeat(beat.id, detail.id)}>Hủy liên kết</button>
                        <pre className="base-song-lyric mt-3">{beat.fullLyric || "Không có lời hợp lệ"}</pre>
                        <div className="input-group mt-2">
                            <input className="form-control" placeholder="BaseSong ID đích" value={this.state.assignTargets[beat.id] || ""}
                                   onChange={event => this.setState({ assignTargets: Object.assign({}, this.state.assignTargets, { [beat.id]: event.target.value }) })} />
                            <div className="input-group-append"><button className="btn btn-outline-danger" onClick={() => this.assignBeat(beat.id)}>Chuyển beat</button></div>
                        </div>
                    </details>)}
                </div>
            </div>
        );
    }

    renderReviewDetail(detail) {
        return (
            <div className="base-song-detail">
                <div className="base-song-detail-dialog">
                    <div className="d-flex justify-content-between align-items-start">
                        <div><h3>{detail.songName}</h3><div className="text-muted">Beat cần review #{detail.songId}</div></div>
                        <button className="btn btn-light" onClick={() => this.setState({ detail: null, detailMode: null, candidateDetail: null, linkedBaseSong: null })}>Đóng</button>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-4"><b>Ca sĩ</b><div>{detail.singer || "-"}</div></div>
                        <div className="col-md-4"><b>Thể loại beat</b><div>{detail.genre || "-"}</div></div>
                        <div className="col-md-4"><b>Điểm lần phân loại</b><div>{typeof detail.lyricScore === "number" ? detail.lyricScore.toFixed(3) : "-"}</div></div>
                    </div>
                    <h5 className="mt-4">Lời bài hát đầy đủ</h5>
                    <pre className="base-song-lyric">{detail.fullLyric || "Không có lời hợp lệ"}</pre>
                    <div className="d-flex justify-content-between align-items-center mt-4">
                        <h5 className="mb-0">BaseSong nghi vấn (cùng tên hoặc khớp lyric)</h5>
                        {this.state.tab !== "missingLyric" && <button className="btn btn-success" onClick={this.openCreateBaseSongModal}>Giữ riêng, tạo BaseSong mới</button>}
                    </div>
                    {(detail.candidates || []).map(candidate => <div className="base-song-candidate" key={candidate.baseSongId}>
                        <div>
                            <b>#{candidate.baseSongId} – {candidate.songName}</b>
                            <div>{candidate.authorName || "Chưa có tác giả"} · {candidate.genre || "Chưa có thể loại"}</div>
                            <small className="text-muted">Title: {(candidate.titleScore || 0).toFixed(3)} · Lyric: {(candidate.lyricScore || 0).toFixed(3)} · {candidate.reason}</small>
                        </div>
                        <div className="text-nowrap">
                            <button className="btn btn-outline-secondary mr-2" onClick={() => this.openCandidateDetail(candidate.baseSongId)}>Xem chi tiết</button>
                            <button className="btn btn-primary" onClick={() => this.setState({ assignTargets: Object.assign({}, this.state.assignTargets, { [detail.songId]: candidate.baseSongId }) }, () => this.assignBeat(detail.songId))}>Gắn vào bài này</button>
                        </div>
                    </div>)}
                    {(detail.candidates || []).length === 0 && <div className="alert alert-info mt-3">
                        Không tìm thấy BaseSong nghi vấn. {this.state.tab === "missingLyric"
                            ? "Cần bổ sung lyric hợp lệ hoặc tìm BaseSong thủ công theo tên; hệ thống không tạo BaseSong từ lyric trống."
                            : "Admin có thể tạo bài mới sau khi kiểm tra lyric."}
                    </div>}
                    {this.state.tab === "missingLyric" && <div className="alert alert-warning mt-3">
                        Beat này đang thiếu lyric hợp lệ nên không được dùng để tạo BaseSong hay làm candidate lyric.
                        Chỉ gắn vào BaseSong sau khi Admin xác nhận bằng tên và thông tin beat.
                    </div>}
                    <form className="mt-4" onSubmit={this.searchBaseSongs}>
                        <label><b>Tìm BaseSong khác theo tên bài hát</b></label>
                        <div className="input-group">
                            <input className="form-control" placeholder="Nhập tên BaseSong" value={this.state.baseSongSearchQuery}
                                   onChange={event => this.setState({ baseSongSearchQuery: event.target.value })} />
                            <div className="input-group-append"><button className="btn btn-outline-primary" disabled={this.state.searchingBaseSongs} type="submit">Tìm BaseSong</button></div>
                        </div>
                    </form>
                    {(this.state.baseSongSearchResults || []).map(candidate => <div className="base-song-candidate" key={"search-" + candidate.id}>
                        <div><b>#{candidate.id} – {candidate.songName}</b><div>{candidate.authorName || "Chưa có tác giả"} · {candidate.genre || "Chưa có thể loại"}</div><small className="text-muted">{candidate.beatCount || 0} beat · {candidate.status}</small></div>
                        <div className="text-nowrap">
                            <button className="btn btn-outline-secondary mr-2" onClick={() => this.openCandidateDetail(candidate.id)} type="button">Xem chi tiết</button>
                            <button className="btn btn-primary" onClick={() => this.setState({ assignTargets: Object.assign({}, this.state.assignTargets, { [detail.songId]: candidate.id }) }, () => this.assignBeat(detail.songId))} type="button">Gắn vào bài này</button>
                        </div>
                    </div>)}
                    <div className="input-group mt-3">
                        <input className="form-control" placeholder="Hoặc nhập BaseSong ID" value={this.state.assignTargets[detail.songId] || ""}
                               onChange={event => this.setState({ assignTargets: Object.assign({}, this.state.assignTargets, { [detail.songId]: event.target.value }) })} />
                        <div className="input-group-append"><button className="btn btn-outline-primary" onClick={() => this.assignBeat(detail.songId)}>Gắn thủ công</button></div>
                    </div>
                </div>
            </div>
        );
    }

    renderCreateModal() {
        const form = this.state.createModal;
        if (!form) return null;
        return (
            <div className="base-song-detail base-song-create-overlay">
                <div className="base-song-detail-dialog base-song-create-dialog">
                    <div className="d-flex justify-content-between align-items-start">
                        <div><h3>Xác nhận BaseSong mới</h3><div className="text-muted">Từ beat #{form.songId}</div></div>
                        <button className="btn btn-light" onClick={() => this.setState({ createModal: null })}>Đóng</button>
                    </div>
                    <div className="alert alert-warning mt-3">Kiểm tra đúng tác phẩm, tác giả sáng tác và thể loại trước khi tạo. Các giá trị dưới đây có thể được gợi ý từ dữ liệu beat.</div>
                    <div className="form-group"><label>Tên bài hát</label><input className="form-control" value={form.songName} onChange={event => this.updateCreateModal("songName", event.target.value)} /></div>
                    <div className="form-group"><label>Tác giả</label><input className="form-control" value={form.authorName} placeholder="Nhạc sĩ/composer, không phải ca sĩ" onChange={event => this.updateCreateModal("authorName", event.target.value)} /></div>
                    <div className="form-group"><label>Thể loại</label><input className="form-control" value={form.genre} placeholder="Ví dụ: Pop, Rock, Trữ tình" onChange={event => this.updateCreateModal("genre", event.target.value)} /></div>
                    <div className="text-right">
                        <button className="btn btn-light mr-2" onClick={() => this.setState({ createModal: null })}>Hủy</button>
                        <button className="btn btn-success" onClick={this.createBaseSongFromReview}>Xác nhận tạo mới</button>
                    </div>
                </div>
            </div>
        );
    }

    renderCandidateDetail() {
        const candidate = this.state.candidateDetail;
        const source = this.state.detail;
        if (!candidate || !source) return null;
        const scoredCandidate = (source.candidates || []).find(item => item.baseSongId === candidate.id);
        return (
            <div className="base-song-detail base-song-candidate-detail-overlay">
                <div className="base-song-detail-dialog base-song-compare-dialog">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <h3>So sánh beat với BaseSong</h3>
                            <div className="text-muted">Kiểm tra hai bài trước khi quyết định gắn</div>
                        </div>
                        <button className="btn btn-light" onClick={() => this.setState({ candidateDetail: null })}>Đóng</button>
                    </div>
                    <div className="base-song-compare-grid mt-4">
                        <section className="base-song-compare-column base-song-compare-source">
                            <div className="base-song-compare-heading">
                                <span className="badge badge-warning">Beat cần review</span>
                                <h4 className="mt-2 mb-1">{source.songName || "Chưa có tên bài"}</h4>
                                <div className="text-muted">Song #{source.songId}</div>
                            </div>
                            <dl className="base-song-compare-metadata">
                                <dt>Ca sĩ</dt><dd>{source.singer || "Chưa có"}</dd>
                                <dt>Thể loại beat</dt><dd>{source.genre || "Chưa có"}</dd>
                                <dt>Điểm phân loại</dt><dd>{typeof source.lyricScore === "number" ? source.lyricScore.toFixed(3) : "-"}</dd>
                            </dl>
                            <h5>Lời beat đầy đủ</h5>
                            <pre className="base-song-lyric base-song-compare-lyric">{source.fullLyric || "Không có lời hợp lệ"}</pre>
                        </section>
                        <section className="base-song-compare-column base-song-compare-target">
                            <div className="base-song-compare-heading">
                                <span className="badge badge-primary">BaseSong đích</span>
                                <h4 className="mt-2 mb-1">{candidate.songName}</h4>
                                <div className="text-muted">BaseSong #{candidate.id}</div>
                            </div>
                            <dl className="base-song-compare-metadata">
                                <dt>Tác giả</dt><dd>{candidate.authorName || "Chưa có"}</dd>
                                <dt>Thể loại</dt><dd>{candidate.genre || "Chưa có"}</dd>
                                <dt>Số beat</dt><dd>{candidate.beatCount || 0}</dd>
                                {scoredCandidate && <React.Fragment>
                                    <dt>Điểm title</dt><dd>{(scoredCandidate.titleScore || 0).toFixed(3)}</dd>
                                    <dt>Điểm lyric</dt><dd>{(scoredCandidate.lyricScore || 0).toFixed(3)}</dd>
                                </React.Fragment>}
                            </dl>
                            <h5>Lời BaseSong đầy đủ</h5>
                            <pre className="base-song-lyric base-song-compare-lyric">{candidate.fullLyric || "Không có lời hợp lệ"}</pre>
                        </section>
                    </div>
                    <details className="base-song-beat mt-3">
                        <summary><b>Xem toàn bộ beat đang thuộc BaseSong ({(candidate.beats || []).length})</b></summary>
                        {(candidate.beats || []).map(beat => <details className="base-song-beat mt-3" key={beat.id}>
                            <summary><b>#{beat.id} – {beat.songName}</b> <span className="text-muted">{beat.singer || "Không rõ ca sĩ"}</span></summary>
                            <pre className="base-song-lyric mt-3">{beat.fullLyric || "Không có lời hợp lệ"}</pre>
                        </details>)}
                    </details>
                    <div className="d-flex justify-content-end mt-3">
                        <button className="btn btn-light mr-2" onClick={() => this.setState({ candidateDetail: null })}>Quay lại</button>
                        <button className="btn btn-primary" onClick={() => this.setState({
                            assignTargets: Object.assign({}, this.state.assignTargets, { [source.songId]: candidate.id })
                        }, () => this.assignBeat(source.songId))}>Gắn beat vào BaseSong này</button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div id="content" className="base-song-page">
                <div className="container-fluid">
                    <div>
                        <h1>Chuẩn hóa BaseSong</h1>
                        <p className="text-muted">Review mapping beat, tác giả, thể loại và lời bài hát dạng text.</p>
                    </div>
                    <div className="btn-group mb-3 flex-wrap">
                        <button className={"btn " + (this.state.tab === "review" ? "btn-warning" : "btn-outline-warning")} onClick={() => this.switchTab("review")}>Beat cần review</button>
                        <button className={"btn " + (this.state.tab === "missingLyric" ? "btn-danger" : "btn-outline-danger")} onClick={() => this.switchTab("missingLyric")}>Beat thiếu lyric</button>
                        <button className={"btn " + (this.state.tab === "baseReview" ? "btn-warning" : "btn-outline-warning")} onClick={() => this.switchTab("baseReview")}>Kiểm duyệt tác giả/thể loại</button>
                        <button className={"btn " + (this.state.tab === "missingMetadata" ? "btn-danger" : "btn-outline-danger")} onClick={() => this.switchTab("missingMetadata")}>BaseSong chưa có thể loại/tác giả</button>
                        <button className={"btn " + (this.state.tab === "all" ? "btn-primary" : "btn-outline-primary")} onClick={() => this.switchTab("all")}>Tất cả BaseSong</button>
                    </div>
                    {this.renderSearch()}
                    {this.renderTable()}
                </div>
                {this.renderDetail()}
                {this.renderCreateModal()}
                {this.renderCandidateDetail()}
            </div>
        );
    }
}

